<template>
    <div>
        <span class="iis" @click="signin" :style="{ color: userSign.is_today_singin ? '#9c623c' : '#3c9c8f' }">{{
            userSign.is_today_singin ? "已签到" :
                "签到" }}</span>
        <RewardDialog :visible.sync="showRewardDialog" :today-reward="todayReward" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RewardDialog from "./RewardDialog.vue";
export default {
    name: "Sign",
    components: {
        RewardDialog
    },
    data() {
        return {
            userSign: {},
            todayReward: {},//今日奖项
            signConfig: {},
            isInit: false,
            showRewardDialog: false
        }
    },
    computed: {
        ...mapGetters(["user", 'base'])
    },
    watch: {
        // 有用户信息和base后才能调用接口
        base: {
            handler(newVal) {
                if (Object.keys(newVal).length > 0 && Object.keys(this.user).length > 0) {
                    this.initList()
                }

            }
        },
        user: {
            handler(newVal) {
                if (Object.keys(newVal).length > 0 && Object.keys(this.base).length > 0) {
                    this.initList()
                }

            }
        },

    },
    created() {
        this.initSign()
    },
    methods: {
        ...mapActions(["getUser"]),
        async initSign() {

            await this.getSign()
            this.signConfig = this.base.signin;
            // 排序
            if (!(this.signConfig && this.signConfig.continuity_signin_rule)) {
                return
            }
            this.signConfig.continuity_signin_rule = this.signConfig.continuity_signin_rule.slice().sort((a, b) => a.day - b.day);
            // 初始化列表
            this.initList()
        },
        async getSign() {
            try {
                const res = await this.$api.getSign()
                if (res.code == 1) {
                    this.userSign = res.data

                }
            } catch (error) {
                console.log(error)
            }
        },
        // 初始化签到列表
        initList() {
            this.isInit = true
            if (!this.isInit) {
                return
            }
            this.list = []
            this.signConfig = this.base.signin
            if (!this.signConfig) {
                return
            }
            for (var i = 0; i < this.signConfig.day; i++) {
                // 这一天是否有特殊奖励，如果有替换当天数据
                let reward = this.getReward(i)
                if (reward) {
                    this.list.push({
                        day: i + 1,
                        reward_type: reward.reward_type,
                        signin_reward: reward.signin_reward,
                        signin_icon: reward.icon,
                        fontColor: '#fff'
                    })
                } else {
                    this.list.push({
                        day: i + 1,
                        reward_type: this.signConfig.reward_type,
                        signin_reward: this.signConfig.signin_reward,
                        signin_icon: this.signConfig.signin_icon,
                        fontColor: '#b65120'
                    })
                }

            }
            if (this.userSign) {
                this.getToday()
            }
        },
        //获取特殊奖励
        getReward(index) {
            return this.signConfig.continuity_signin_rule.find(reward => reward.day === index + 1);
        },
        getToday() {
            if (this.userSign.is_today_singin == 0) {
                this.todayReward = this.list[this.userSign.continuity_signin_day]
            } else {
                this.todayReward = this.list[this.userSign.continuity_signin_day - 1]
            }
            if (!this.todayReward) {
                this.isInit = false
            }
            console.log('today', this.todayReward);
        },
        async signin() {
            try {
                const res = await this.$api.signin()
                if (res.code === 1) {
                    this.showRewardDialog = true
                    this.getSign()
                    this.getUser()
                } else {
                    this.$message.error(res.message || '签到失败')
                }
            } catch (err) {
                this.$message.error(err.message || '签到失败')
            }
        }
    }

}
</script>

<style lang="less" scoped>
.iis {
    cursor: pointer;
    color: #3c9c8f;
    font-size: 14px;
    line-height: 25px;
}
</style>